<div class="content">
  <p class="mb-xlg">
    <i nz-icon nzType="check-circle" nzTheme="twotone" style="font-size: 50px;" [nzTwotoneColor]="'#52c41a'"></i>
  </p>
  <p class="text-title-lgx-bold mb-md text-center">¡Ya casi registras tu clínica!</p>
  <p class="text-info text-upper-case text-center">
    Disfruta tu periodo de 1 mes de prueba gratis
    <i nz-icon nzType="heart" [nzTheme]="'twotone'" [nzTwotoneColor]="'#eb2f96'"></i>
  </p>
</div>
